import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { ProductCard } from './ProductCard';
import type { OrderProductFlat } from './types';
interface ProductCardListProps {
  products: OrderProductFlat[];
  orderId: string;
  orderNo: string;
  orderType?: string;
  orderStatus?: string;
  orderStatusName?: string;
  onVendorInfoClick?: () => void;
}
export const ProductCardList = t0 => {
  const $ = _c(18);
  const {
    products,
    orderId,
    orderNo,
    orderType,
    orderStatus,
    orderStatusName,
    onVendorInfoClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex flex-col gap-56", "mobile-tablet:gap-20");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onVendorInfoClick || $[2] !== orderId || $[3] !== orderNo || $[4] !== orderStatus || $[5] !== orderStatusName || $[6] !== orderType || $[7] !== products) {
    let t3;
    if ($[9] !== onVendorInfoClick || $[10] !== orderId || $[11] !== orderNo || $[12] !== orderStatus || $[13] !== orderStatusName || $[14] !== orderType) {
      t3 = product => <ProductCard key={product.productName} product={product} orderId={orderId} orderNo={orderNo} orderType={orderType} orderStatus={orderStatus} orderStatusName={orderStatusName} onVendorInfoClick={onVendorInfoClick} deliveryId={product.deliveryId} />;
      $[9] = onVendorInfoClick;
      $[10] = orderId;
      $[11] = orderNo;
      $[12] = orderStatus;
      $[13] = orderStatusName;
      $[14] = orderType;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t2 = products.map(t3);
    $[1] = onVendorInfoClick;
    $[2] = orderId;
    $[3] = orderNo;
    $[4] = orderStatus;
    $[5] = orderStatusName;
    $[6] = orderType;
    $[7] = products;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[16] !== t2) {
    t3 = <ul className={t1}>{t2}</ul>;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};